export default {
  // 首页埋点
  userteam_ad_zj_begin_en: 'UT-投放-落地页-初始化进入事件',
  userteam_ad_zj_loadpage_sw: 'UT-投放-领券H5-落地页-展现',
  userteam_ad_zj_loadpage_time_bt: 'UT-投放-领券H5-落地页-时长上报',

  // 领券组件埋点
  userteam_ad_zj_loadpage_inputbox_ck: 'UT-投放-组件化-落地页-表单输入框-点击',
  userteam_ad_zj_loadpage_done_ck: 'UT-投放-领券H5-落地页-领取（表单done）-点击',
  userteam_ad_zj_lingqu_bt: 'UT-投放-领券H5-落地页-领取结果返回',

  // 通用按钮点击埋点
  userteam_ad_zj_loadpage_button_ck: 'UT-投放-领券H5-落地页-按钮-点击',
  // 通用组件曝光（图片、轮播图、视频、背景音乐、倒计时、计数器、跑马灯、隐私协议）
  userteam_ad_zj_pub_sw: 'UT个性化承接落地页_组件曝光',
  userteam_launch_app_user_guide_popup_sw: 'UT个性化承接落地页-引导页展现',
  // 挽留弹窗埋点
  userteam_ad_zj_wanliu_sw: 'UT-投放-领券H5-挽留弹窗-展现',
  userteam_ad_zj_wanliu_done_ck: 'UT-投放-领券H5-挽留弹窗-确认点击',
  userteam_ad_zj_wanliu_leave_ck: 'UT-投放-领券H5-挽留弹窗-退出-点击',

  // 结果页埋点
  userteam_ad_zj_result_sw: 'UT-投放-领券H5-结果页-曝光',
  userteam_ad_zj_result_done_ck: 'UT-投放-领券H5-结果页-确定-点击',
  userteam_ad_zj_result_back_ck: 'UT-投放-领券H5-结果页-返回-点击',

  // 拉端埋点
  userteam_ad_zj_countdown_sw: 'UT-投放落地页倒计时弹窗-展现',
  userteam_ad_zj_countdown_no_ck: 'UT-投放落地页倒计时弹窗-暂不-点击',
  userteam_ad_zj_countdown_open_ck: 'UT-投放落地页倒计时弹窗-调端-点击',
  userteam_ad_zj_diaoqi_bt: '触发调端',
  userteam_ad_zj_diaoqi_success_bt: '调端成功-前端预判',

  // 支付
  userteam_ad_zj_go_pay_ck: 'UT-投放-组件化-进入支付（购买）点击',
  userteam_ad_zj_pay_sw: 'UT-投放-组件化-支付表单页面曝光',
  userteam_ad_zj_pay_done_ck: 'UT-投放-组件化-支付-表单页面-确认-点击',
  userteam_ad_zj_pay_explain_ck: 'UT-投放-组件化-支付-表单页面-说明-点击',
  userteam_ad_zj_pay_leave_ck: 'UT-投放-组件化-支付-表单页面-离开-点击',
  userteam_ad_zj_pay_result_bt: 'UT-投放-组件化-支付-结果返回',

  // 活动规则点击
  userteam_ad_zj_huodong_ck: 'UT-投放-组件化-落地页-活动规则-点击',

  // 多端跳转组件埋点
  userteam_ad_zj_loadpage_skip_done_ck: 'UT-投放-组件化-落地页-调端或跳转-点击',

  // 登录场景
  userteam_ad_zj_login_pre_bt: 'UT-投放-组件化-登录-准备进入',
  userteam_ad_zj_login_success_bt: 'UT-投放-组件化-登录-成功结果返回',
  // 资源位
  userteam_ad_zj_loadpage_main_sw: 'UT-投放-组件化-落地页-金刚位-曝光',
  userteam_ad_zj_loadpage_main_ck: 'UT-投放-组件化-落地页-金刚位-点击',
  // 复制按钮
  userteam_ad_zj_loadpage_copy_button_ck: 'UT-投放-组件化-落地页-复制按钮-点击',

  // 司机招募
  userteam_ad_zj_law_ck: 'UT-投放-组件化-落地页-法律协议-点击',
  userteam_ad_zj_app_store_bt: 'UT-投放-组件化-触发应用商城',
  userteam_ad_zj_download_result_bt: 'UT-投放-组件化-下载触发',
  userteam_ad_zj_register_ck: 'UT-投放-组件化-落地页-立即注册-点击'
}
